
import React from "react";

function ClearfixChildren({ block, children, ...props }) {
    const SpanOrDiv = block ? 'div' : 'span';
    return (
        <SpanOrDiv {...props}>
            {children}
            <div className="custom-clearfix"></div>
        </SpanOrDiv>
    );
}

export default ClearfixChildren;


// WEBPACK FOOTER //
// ./src/components/Custom/ClearfixChildren.jsx